/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';
import {Button, Row, Col} from 'react-bootstrap'

import GeneralTable from '../general_table.js';
import Translation from '../../store/internationalization-store.js';
import {AccountService, ClassesService} from '../../services/';
import {ClassesStore} from '../../store';
import Constants from '../../constants.js';
import CreateStudent from '../../components/popup/new_student.js'
import GeneratePDF from '../../classes/pdf_generate.js';
import Comfirmation from '../../components/popup/comfirmation_popup.js';
import Popup from '../../components/popup/comfirmation_popup.js'
import FieldGroup from '../../components/FieldGroup.js';


export default class Members extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"students",
            toggle:false,
        };
    }

    componentWillMount(){
        ClassesStore.on(Constants.GET_STUDENTS , () =>{
            this.setState({
                students:ClassesStore.students || []
            })

        })
    }

    componentDidMount(){
        ClassesService.getStudents(this.props.classID)
    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.tab)
        {
            case "students" : return <h4>Students</h4>
            case "staff" : return <h4>Students</h4>
        }
    }

    handelDownload(){
        this.PDFgen = new GeneratePDF();
        var students = this.state.students || [];
        this.PDFgen.generateClassPDF(this.props.name, this.state.students);
    }

    renderProfileLink(cell, row){
        return <a href="#">{cell}</a>
    }

    percentage(){
        return <span>0%</span>
    }


    getHeader(title){

        switch(title)
        {
            case "name" : return Translation.get(827 , 'Student Name');
            case "username" : return Translation.get(22 , 'Username');
            case "password" : return Translation.get(23 , 'Password');
            case "vocabLearnt" : return Translation.get(12605 , 'Vocabulary Learnt');
            case "verbLearnt" : return Translation.get(12193 , 'Verbs Learnt');
            case "grammarLearnt" : return Translation.get(12602, 'Grammar Units Learnt');
            case "sentenceLearnt" : return Translation.get(12194 , 'Sentences Learnt');
            case "goldMedals" : return Translation.get(12619 , 'Gold Medals');
            case "silverMedals" : return Translation.get(12620 , 'Silver Medals');
            case "bronzeMedals" : return Translation.get(12621 , 'Bronze Medals');
            case "totalScore" : return Translation.get(12622 , 'World Score');
            case "rank" : return Translation.get(37 , 'World Ranking');
            case "examsCompleted" : return Translation.get(12042 , 'Exam Skills');
            case "last_login" : return Translation.get(17327 , 'Login');
        }

        return title
    }

    getPostition(title){

        switch(title)
        {
            case "name" : return 0;
            case "username" : return 1;
            case "password" : return 2;
            case "last_login" : return 3;
            case "vocabLearnt" : return 4;
            case "verbLearnt" : return 7;
            case "grammarLearnt" : return 6;
            case "sentenceLearnt" : return 5;
            case "goldMedals" : return 9;
            case "silverMedals" : return 10;
            case "bronzeMedals" : return 11;
            case "totalScore" : return 13;
            case "rank" : return 12;
            case "examsCompleted" : return 8;
        }

        return 0;
    }


    isSort(title){

        switch(title)
        {
            case "username" : return false
            case "password" : return false
            case "name" : return false
        }

        return true
    }

    getCols(){

        var json = this.state.students[0];

        var k = Object.keys(json);
        var c = [];
        var total = [];

        for(var i = 0 ; i < k.length; i++)
        {
            if (i == 1) {
                var number = this.getPostition(k[i]);
                total[number] = {
                dataField: k[i],
                text:  this.getHeader(k[i]),
                sort: this.isSort(k[i]),
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (dataField == "last_login") {
                        var arr = a.split('/');
                        a = new Date(arr[2], arr[1] - 1, arr[0]);
                        var arr = b.split('/');
                        b = new Date(arr[2], arr[1] - 1, arr[0]);
                        if (order === 'asc') {
                            if (a < b) {
                                return -1
                            } else {
                                return 1
                            }
                        }
                        if (a > b) {
                            return -1
                        } else {
                            return 1
                        }  
                    }
                    if (order === 'asc') {
                        if (parseInt(a) < parseInt(b)) {
                            return -1
                        } else {
                            return 1
                        }
                    }
                    if (parseInt(a) > parseInt(b)) {
                        return -1
                    } else {
                        return 1
                    }
                    // desc
                },
                formatter: (cell, row)=>{
                    return <b onClick={function(){window.location.hash = 'students/overview/' + row.uid}} className="hyperlink">{cell}</b>
                }
                };
            } else {
                if(k[i] == 'is_message_display' || k[i] == 'active_students' || k[i] == 'totalScore' || k[i] == 'uid' 
                        || k[i] == 'rank' || this.state.students[0][k[i]] == null) {
                    continue;
                }
                var number = this.getPostition(k[i]);
                total[number] = {
                    dataField: k[i],
                    text:  this.getHeader(k[i]),
                    sort: this.isSort(k[i]),
                    sortFunc: (a, b, order, dataField, rowA, rowB) => {
                        if (dataField == "last_login") {
                            var arr = a.split('/');
                            a = new Date(arr[2], arr[1] - 1, arr[0]);
                            var arr = b.split('/');
                            b = new Date(arr[2], arr[1] - 1, arr[0]);
                            if (order === 'asc') {
                                if (a < b) {
                                    return -1
                                } else {
                                    return 1
                                }
                            }
                            if (a > b) {
                                return -1
                            } else {
                                return 1
                            }  
                        }
                        if (order === 'asc') {
                            if (parseInt(a) < parseInt(b)) {
                                return -1
                            } else {
                                return 1
                            }
                        }
                        if (parseInt(a) > parseInt(b)) {
                            return -1
                        } else {
                            return 1
                        }
                        // desc
                    },
                    formatter: (cell)=>{

                        if(!cell) return 0;
                        return cell;
                    }
                };
            }
        }

        total.push({
            dataField: 'delete',
            text:  '',
            csvExport: false,
            formatter: (cell, row)=>{
                return <div onClick={function() {
                    this.setState({action:"deleteStudent", deletedStudent:row.uid});
                }.bind(this)}><i class="fas fa-trash-alt"></i></div>;
            }
        })

        total.push({
            dataField: 'message',
            text:"",
            csvExport: false,
            formatter: (cell, row)=>{
                var color = "#FF0000";
                if (row.is_message_display != "1") {
                    color = "#00FF00";
                }
                
                return <div onClick={function() {
                    this.setState({addMessage:true, messageMessage:"", messageTitle:"", studentUid:row.uid, studentName:row.name});
                }.bind(this)}><i style={{color:color}} class="fas fa-envelope"></i></div>;
            }
        })

        for (var i = 0; i < 14; i++) {
            if (total[i] != undefined) {
                c.push(total[i]);
            }
        }
        return c
    }

    render(){

        if (!this.state.students || this.state.students.length < 1) {
            return "";
        }

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={this.state.studentName} 
        onSave={()=>{
            AccountService.createMessageStudent(this.state.messageTitle, this.state.messageMessage, this.state.studentUid)
            this.setState({addMessage:false});
        }} 
        onHide={()=>{
            this.setState({addMessage:false});
        }} 
        show={this.state.addMessage} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageTitle} 
                                onSelect={(event)=>{
                                    this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                }} 
                                onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                    </Col>
                </Row>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageMessage} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                    </Col>
                </Row>
                {AccountService.getEmojiData(this)}
            </div>} />

        return <div>
            {popup}
            <Comfirmation onSave={function() {
                ClassesService.removeUser(this.props.classID, this.state.deletedStudent).then(function(){
                        ClassesService.getStudents(this.props.classID);
                    }.bind(this))
                }.bind(this)} body={Translation.get(12623 , 'Are you sure you want to delete this student?')} 
                    onHide={()=>{this.setState({action:""})}} show={this.state.action == 'deleteStudent'} />
            <Comfirmation onSave={this.handelDownload.bind(this)} body={Translation.get(12624 , 'Would you like to download your student logins now?')} onHide={()=>{ window.location.hash = 'classes/students/'+this.props.classID; }} show={this.props.action == 'download'} />
            <CreateStudent classID={this.props.classID} show={this.state.show} onHide={()=>{ this.setState({show:false})}} />
            <div>
                <GeneralTable pageSize={40} component={ <span><Button onClick={()=>{ this.setState({show:true})}}  >{Translation.get(865,'Add Student')}</Button>  <Button onClick={()=>{ this.handelDownload()}}  >{Translation.get(12759,'Download Logins')}</Button></span>} bordered={ true } keyField='id' data={ this.state.students || [] } columns={ this.getCols() } />
            </div>
        </div>
    }
}
